export default {
  getList: {
    method: 'post',
    url: '/client/vehicle/remooc/list'
  },
  getById: {
    method: 'get',
    url: '/client/vehicle/remooc/ID'
  },
  add: {
    method: 'post',
    url: '/client/vehicle/remooc'
  },
  delete: {
    method: 'delete',
    url: '/client/vehicle/remooc'
  },
  archive: {
    method: 'delete',
    url: '/client/vehicle/remooc/archive'
  },
  restore: {
    method: 'put',
    url: '/client/vehicle/remooc/restore'
  },
  edit: {
    method: 'put',
    url: '/client/vehicle/remooc/id'
  },
  find: {
    method: 'get',
    url: '/client/vehicle/remooc/find?key=KEY'
  },
  archiveDocument: {
    method: 'delete',
    url: '/client/vehicle/remooc-document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/client/vehicle/remooc-document/restore'
  }
}
